import { format, formatISO, isValid, parseISO, sub } from "date-fns"
import { nl } from "date-fns/locale"

export function extractTimeFromDateTimeInMinutes(date: Date) {
  return date.getHours() * 60 + date.getMinutes()
}

export function formatDateLocalized(date: Date | string | null, formatString = "PP", locale = nl) {
  if (!date) {
    return ""
  } else {
    return format(new Date(date), formatString, { locale })
  }
}

export function dateObjectToDateString(date: Date | null) {
  if (!date) {
    return null
  }
  const offset = date.getTimezoneOffset()
  const dateWithOffset = sub(date, { minutes: offset })

  return dateWithOffset.toISOString().split("T")[0]
}

export function dateToIso(date: Date | null): string {
  return date ? formatISO(date) : ""
}

export function createDateOrNull(dateString: string) {
  const date = parseISO(dateString)

  return isValid(date) ? date : null
}

export function parseValidDate(date: string | null): Date | null {
  if (!date) return null
  return isValid(parseISO(date)) ? parseISO(date) : null
}
